<template>
    <div class="logo">
        <svg
            height="60"
            viewBox="0 0 49 60"
            width="49"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
        >
            <title>Flutter Developers</title>
            <g transform="translate(-75 -43)">
                <path :fill="colour === '#FFF' ? '#ccc' : '#1289FD'" d="m75 75.668v27.332l15.826-9.669.174-27.331z" />
                <path :fill="colour === '#FFF' ? '#ccc' : '#1289FD'" d="m75 74.61 31.056 18.39 17.944-10.61-31.056-18.39z" />
                <path :fill="colour === '#FFF' ? '#ececec' : '#56ABFF'" d="m75 63.61 30.947 18.39 18.053-10.61-30.947-18.39z" />
                <path :fill="colour === '#FFF' ? '#fff' : '#6FB8FF'" d="m92.944 43-17.944 10.61 31.056 18.39 17.944-10.61z" />
            </g>
        </svg>
        <span :style="{ color: colour }" class="text" aria-hidden="true">
            <strong>Flutter</strong>Developers
        </span>
    </div>
</template>

<script>
    export default {
        name: 'logo',

        props: {
            colour: {
                type: String,
                default: null,
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/vendor/bootstrap/variables";
    @import (reference) "~assets/less/mixins/rem";

    .logo {
        display: flex;
        flex-direction: row;
        align-items: center;
        text-decoration: none;
        color: @secondary-colour;
        .rem-letter-spacing(0.12px);
        @media (min-width: @screen-sm-min) {
            .rem-font-size(40px);
        }
    }

    svg {
        height: 42px;
        width: auto;
        margin-right: 8px;
        @media (min-width: @screen-md-min) {
            height: 58px;
            margin-right: 19px;
        }
    }

    .text {
        @media (min-width: @screen-sm-min) {
            .rem-font-size(15px);
        }

        strong {
            font-weight: 700;
        }
    }
</style>
